/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PostJourneysSearchJourneyResponseFrequentFlyerCard } from './postJourneysSearchJourneyResponseFrequentFlyerCard';

export interface PostJourneysSearchJourneyResponse {
  /**
   * チェックイン先システム<br> SPACE:SPACEシステム（新ASW）, iCAS: iCAS（現行国際線ASW）, able-D: able-D（現行国内線ASW）
   */
  checkinSystem: PostJourneysSearchJourneyResponse.CheckinSystemEnum;
  /**
   * 旅程ID
   */
  journeyId?: string;
  /**
   * 暗号化済み国内線ASW連携パラメータ(チェックイン先システムが国内線ASW(able-D)の場合のみ返却)
   */
  encryptedDomesticAswParameter?: string;
  frequentFlyerCard?: PostJourneysSearchJourneyResponseFrequentFlyerCard;
}
export namespace PostJourneysSearchJourneyResponse {
  export type CheckinSystemEnum = 'SPACE' | 'iCAS' | 'able-D';
  export const CheckinSystemEnum = {
    Space: 'SPACE' as CheckinSystemEnum,
    ICas: 'iCAS' as CheckinSystemEnum,
    AbleD: 'able-D' as CheckinSystemEnum,
  };
}
